import React, { ReactNode } from 'react';
import DialogContent from '@mui/material/DialogContent';
import { ExceptionsDialogActions } from '../../Actions/ExceptionsDialogActions';
import { BaseAlert } from 'components/BaseAlert/BaseAlert';

export function ExceptionsDialogError ({ children }: {children?: ReactNode}) {
  return (
    <>
      <DialogContent>
        <BaseAlert>{children}</BaseAlert>
      </DialogContent>
      <ExceptionsDialogActions allDisabled />
    </>
  )
}
